export const EXP_GG = 30;
export const MAX_EXP_GG = 60;
export const DP_FORMAT = 'YYYY-MM-DD';
export const DP_FORMAT_ALT = 'DD/MM/YYYY';
